import { render, staticRenderFns } from "./OptionsVisualTab.vue?vue&type=template&id=6618f380&"
import script from "./OptionsVisualTab.vue?vue&type=script&lang=js&"
export * from "./OptionsVisualTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports